module.exports = __webpack_public_path__ + "assets/803733ec8249ea7d883ac76a53dc78a4.png";